import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

const QuienesSomosLanding = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, [])

    return (
        <>
            <div className="row m-0 background-landing">
                <div className="col-12 col-sm-1 col-md-2 col-lg-2 p-0" ></div>
                <div className="col-12 col-sm-10 col-md-8 col-lg-8 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h1'>
                            AGENDATE
                        </h1>
                        <h2 className='size-landing-h2'>
                            Es una solución digital diseñada para optimizar la gestión de citas, eventos y reservas con eficiencia,
                            precisión y enfoque estratégico
                        </h2>
                        <h2 className='size-landing-h2'>
                            Para profesionales, AGENDATE no solo es una herramienta de organización:
                        </h2>
                        <h2 className='size-landing-h2'>                            
                            <span className='p-bold'> Es tu escaparate digital, donde tu experiencia, especialidad y disponibilidad se presentan al mundo con claridad y confianza. </span>                            
                        </h2>
                        <h2 className='size-landing-h2'>
                            Una vez registrado, tu perfil será parte del catálogo público de AGENDATE,
                            donde potenciales clientes podrán encontrarte, conocer tus servicios, consultar tu disponibilidad y agendar contigo directamente.
                        </h2>
                    </div>
                </div>
                <div className="col-12 col-sm-1 col-md-2 col-lg-2 p-0" ></div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-1 col-lg-1 p-0" ></div>
                <div className="col-12 col-sm-12 col-md-5 col-lg-5 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h2'>
                            <span className='p-bold'> Nos define una visión clara:</span>
                        </h1>
                        <p className='p-element-target-landing-2 margin-15' >
                            Desarrollamos cada componente con rigor técnico y atención al detalle, priorizando la funcionalidad,
                            la escalabilidad y la coherencia visual. Creemos en el diseño como herramienta de impacto comercial y en la tecnología como medio para simplificar procesos.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-5 col-lg-5 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h2'>
                            <span className='p-bold'>No es solo una plataforma:</span>
                        </h1>
                        <p className='p-element-target-landing-2 margin-15' >
                            Es una propuesta que combina diseño estratégico y desarrollo robusto para transformar la manera en que se gestionan los compromisos.
                            Si su objetivo es simplificar, profesionalizar y escalar, AGENDATE está preparado para acompañarlo.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-1 col-lg-1 p-0" ></div>
            </div>
            <div className="row m-0 background-landing">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h2 text-alin-center-dgc'>
                            <span className='p-bold'>Principios que nos guían:</span>
                        </h1>
                    </div>
                </div>
            </div>
            <div className="row m-0 background-landing">
                <div className="col-12 col-sm-6 col-md-3 col-lg-3 p-0" >
                    <div className='div-target-start'>
                        <FontAwesomeIcon className='icon-start-landing' icon={faStar} />
                        <p className='p-element-target-landing-2 ' >
                            La <span className='p-bold'>claridad</span> como base para una comunicación efectiva.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 col-lg-3 p-0" >
                    <div className='div-target-start'>
                        <FontAwesomeIcon className='icon-start-landing' icon={faStar} />
                        <p className='p-element-target-landing-2 ' >
                            La <span className='p-bold'>modularidad</span> como garantía de crecimiento sostenible.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 col-lg-3 p-0" >
                    <div className='div-target-start'>
                        <FontAwesomeIcon className='icon-start-landing' icon={faStar} />
                        <p className='p-element-target-landing-2 ' >
                            La <span className='p-bold'>consistencia visual</span> como reflejo de profesionalismo.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 col-lg-3 p-0" >
                    <div className='div-target-start'>
                        <FontAwesomeIcon className='icon-start-landing' icon={faStar} />
                        <p className='p-element-target-landing-2 ' >
                            La <span className='p-bold'>eficiencia</span> como valor central en cada interacción.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuienesSomosLanding